export const SWITCH_TYPES = {
  SIMPLE: 'simple',
  BOX: 'box',
  LABEL: 'label',
}
